import React, { useState } from "react";
import { Form } from "react-bootstrap";
import Modalpopup from "../../../../shared/components/Modalpopup";
import DefaultButton from "../../../../shared/components/DefaultButton";

const ReopenReasonModal = ({ show, handleClose, handleConfirm }) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    if (!reason.trim()) {
      setError("Please provide a reason for reopening this ticket");
      return;
    }
    handleConfirm(reason);
    setReason("");
    setError("");
  };

  const handleCancel = () => {
    setReason("");
    setError("");
    handleClose();
  };

  return (
    <Modalpopup show={show} handleClose={handleCancel} actionTitle="Reason for Reopening Ticket">
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>
            <strong>Please provide a reason for changing the status from Closed to New:</strong>
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            value={reason}
            onChange={(e) => {
              setReason(e.target.value);
              setError("");
            }}
            placeholder="Enter the reason for reopening this ticket..."
            isInvalid={!!error}
          />
          <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
        </Form.Group>
      </Form>

      <div className="d-flex justify-content-end gap-2">
        <DefaultButton
          buttonClass="btn-secondary"
          buttonTitle="Cancel"
          actionBlock={handleCancel}
        />
        <DefaultButton
          buttonClass="default-btn-color"
          buttonTitle="Confirm"
          actionBlock={handleSubmit}
        />
      </div>
    </Modalpopup>
  );
};

export default ReopenReasonModal;
